module.exports = __webpack_public_path__ + "img/yj_open_now.afab4e8c.png";